import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MenuServiceService } from '../../menu-service/menu-service.service';
import { Utils } from 'src/app/core/resources/utils';
import { Router } from '@angular/router';
import { Fmt } from 'src/app/core/messages/fmt';
import { Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { Permission } from 'src/app/core/resources/permission';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { ServiceResources } from '../../resources/services';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { SatelliteLockType } from 'src/app/core/interfaces/satelliteLockType';
import { ServiceLock } from 'src/app/core/interfaces/satelliteLock';

//TODO: Documentar el codigo
@Component({
  selector: 'app-satellite-lock-service-form',
  templateUrl: './satellite-lock-service-form.component.html',
  styleUrls: ['./satellite-lock-service-form.component.scss']
})
export class SatelliteLockServiceFormComponent implements OnInit, OnDestroy {
  permission = Permission;
  formSubscription: Subscription;
  satelliteLockType = new FormControl('', Validators.required);
  isDialog: boolean = false;
  formValidate: string = '';

  optionsSatelliteLockType: OptionsAutocomplete = {
    title: 'Tipo de candado satelital',
    appearance: 'outline'
  };

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public paramsDialog: { cargo: Cargo },
    public dialogRef: MatDialogRef<SatelliteLockServiceFormComponent>,
    public menuService: MenuServiceService,
    private router: Router,
    private snackBarService: SnackBarService,
    private permissionRole: PermissionRole,
    private serviceResources: ServiceResources,
    public utils: Utils
  ) { }

  async ngOnInit() {
    await this.checkDialogParams();
    this.setLocalValues();
    this.setSubscription();
    this.checkPermissionsToEdit();
  }

  private async checkDialogParams() {
    if (this.paramsDialog && this.paramsDialog.cargo) {
      this.isDialog = true;
      this.menuService.cargo = this.paramsDialog.cargo;
      this.menuService.patchForm(this.paramsDialog.cargo, false);
      await this.menuService.setCargoConsignments();
      await this.menuService.setCargoVehicle();
    }
  }

  private setLocalValues() {
    const lock: ServiceLock = this.utils.getNestedValue(this.menuService.form.value, 'lock');
    // Verificar si lock existe y tiene la propiedad type con id y name
    if (lock && lock.type && lock.type.id && lock.type.name) {
      this.satelliteLockType.setValue({ id: lock.type.id, name: lock.type.name });
      this.optionsSatelliteLockType = { ...this.optionsSatelliteLockType, initialValue: lock.type.id };
    }
  }

  private setSubscription() {
    this.formSubscription = this.menuService.formObservable.subscribe(() => this.setLocalValues());
  }

  private checkPermissionsToEdit() {
    if (!this.canEditSatelliteLock) {
      this.satelliteLockType.disable();
      this.formValidate = "disable";
    }
  }

  get canEditSatelliteLock(): boolean {
    return this.permissionRole.hasPermission(
      this.permission.cargo.module,
      this.permission.cargo.editSatelliteLockModule
    );
  }

  /**
   * @description Navigates to the previous step
   */
  backToPreviousStep() {
    this.router.navigate([Fmt.string(this.serviceResources.serviceRequestUrls.loadCharacteristics, this.menuService.cargo.consecutive)]);
  }

  private isValidForm(): boolean {
    if (this.utils.errorMessagesCustomized(this.satelliteLockType, 'tipo de candado satelital')) return false;
    return true;
  }

  /**
   * @description Saves form data and continues if valid
   */
  saveAndContinue() {
    if (this.isDialog && !this.isValidForm()) return;
    if (!this.menuService.form.get('lock')) this.menuService.form.addControl('lock', new FormGroup({
      type: new FormControl(''),
    }));
    const lock: SatelliteLockType = this.satelliteLockType.value as SatelliteLockType;
    this.menuService.form.get('lock.type').setValue({
      id: lock && lock.id ? lock.id : '',
      name: lock && lock.name ? lock.name : '',
    });
    this.menuService.updateService().then(() => {
      this.snackBarService.openSnackBar("Servicio actualizado exitosamente");
      if (!this.isDialog) this.continueToNextStep();
      else this.dialogRef.close({ state: true });
    }).catch(() => this.snackBarService.openSnackBar('Ocurrió un error al actualizar el servicio', undefined, 'error'));
  }

  continueToNextStep() {
    this.router.navigate([Fmt.string(this.serviceResources.serviceRequestUrls.additionalValuesService, this.menuService.cargo.consecutive)]);
  }

  ngOnDestroy() {
    if (this.formSubscription) this.formSubscription.unsubscribe();
  }
}
